import React, { useState } from "react";
import hooptieLogo from "../assets/images/HooptieNewLogo.png";
import "./TermsOfService.css";

const LAST_UPDATED = "February 14, 2026";

const SECTIONS = [
  {
    id: 1,
    title: "1. Eligibility",
    content: "You must be at least 18 years old and legally capable of entering into binding contracts. If you use Hooptie on behalf of a dealership or company, you represent that you have authority to bind that entity.",
  },
  {
    id: 2,
    title: "2. Description of Service",
    content: (
      <>
        <p>Hooptie provides:</p>
        <ul>
          <li>Market analytics based on active and sold listings</li>
          <li>AI-generated pricing and sourcing recommendations</li>
          <li>Vehicle demand scoring</li>
          <li>Competitive analysis</li>
          <li>Inventory performance insights</li>
          <li>Recommended private-party listings</li>
        </ul>
        <p>Hooptie is an informational and analytical tool only.</p>
        <p>We do not:</p>
        <ul>
          <li>Guarantee profit</li>
          <li>Guarantee resale value</li>
          <li>Guarantee accuracy of third-party listing data</li>
          <li>Participate in vehicle transactions</li>
          <li>Provide financial, legal, or investment advice</li>
        </ul>
        <p>All purchasing decisions are made at your own discretion and risk.</p>
      </>
    ),
  },
  {
    id: 3,
    title: "3. No Financial or Investment Advice",
    content: (
      <>
        <p>Hooptie provides data-driven insights and algorithmic recommendations. These insights:</p>
        <ul>
          <li>Are estimates</li>
          <li>May rely on third-party data</li>
          <li>May contain errors</li>
          <li>Do not guarantee results</li>
        </ul>
        <p>You acknowledge that vehicle sourcing decisions involve risk and that Hooptie is not liable for losses.</p>
      </>
    ),
  },
  {
    id: 4,
    title: "4. Subscription & Billing",
    content: (
      <>
        <p>Hooptie operates on a recurring subscription basis.</p>
        <p>By subscribing, you authorize us to:</p>
        <ul>
          <li>Charge your payment method monthly</li>
          <li>Automatically renew your subscription unless cancelled</li>
          <li>Charge applicable taxes</li>
        </ul>
        <p>You may cancel at any time through your account dashboard.</p>
      </>
    ),
  },
  {
    id: 5,
    title: "5. 14-Day Money Back Guarantee",
    content: (
      <>
        <p>We offer a 14-day money-back guarantee subject to the following conditions:</p>
        <ul>
          <li>The guarantee applies only to first-time subscriptions.</li>
          <li>Requests must be submitted within 14 calendar days of initial purchase.</li>
          <li>Refund requests must be made in writing to <a href="mailto:support@hooptie.io">support@hooptie.io</a>.</li>
          <li>Abuse of the refund policy (including repeated signups and cancellations) may result in denial.</li>
          <li>Refunds will be processed to the original payment method.</li>
          <li>After 14 days, all payments are non-refundable.</li>
        </ul>
      </>
    ),
  },
  {
    id: 6,
    title: "6. Cancellation",
    content: (
      <>
        <p>You may cancel your subscription at any time.</p>
        <p>Upon cancellation:</p>
        <ul>
          <li>Access continues until the end of the current billing period.</li>
          <li>No prorated refunds will be issued.</li>
          <li>After expiration, access to premium features will be revoked.</li>
        </ul>
        <p>We reserve the right to terminate accounts for violations of these Terms.</p>
      </>
    ),
  },
  {
    id: 7,
    title: "7. Data Accuracy & Third-Party Sources",
    content: (
      <>
        <p>Hooptie relies on third-party data providers and public listings.</p>
        <p>We do not guarantee:</p>
        <ul>
          <li>Accuracy</li>
          <li>Completeness</li>
          <li>Real-time availability</li>
          <li>Correct pricing</li>
          <li>Market stability</li>
        </ul>
        <p>We are not responsible for changes in listing status, price adjustments, or seller actions.</p>
      </>
    ),
  },
  {
    id: 8,
    title: "8. Limitation of Liability (Very Important)",
    content: (
      <>
        <p>To the maximum extent permitted by law:</p>
        <p>Hooptie LLC shall not be liable for:</p>
        <ul>
          <li>Lost profits</li>
          <li>Business losses</li>
          <li>Missed opportunities</li>
          <li>Inventory mispricing</li>
          <li>Dealer losses</li>
          <li>Indirect, incidental, or consequential damages</li>
        </ul>
        <p>Our total liability shall not exceed the amount paid by you in the previous 30 days.</p>
        <p>This section survives termination.</p>
      </>
    ),
  },
  {
    id: 9,
    title: "9. Indemnification",
    content: (
      <>
        <p>You agree to indemnify and hold harmless Hooptie LLC from claims arising from:</p>
        <ul>
          <li>Your use of the platform</li>
          <li>Your purchasing decisions</li>
          <li>Violations of law</li>
          <li>Misuse of data</li>
        </ul>
      </>
    ),
  },
  {
    id: 10,
    title: "10. Intellectual Property",
    content: (
      <>
        <p>All software, algorithms, designs, dashboards, scoring models, and branding are the property of Hooptie LLC.</p>
        <p>You may not:</p>
        <ul>
          <li>Copy</li>
          <li>Reverse engineer</li>
          <li>Resell</li>
          <li>Reproduce</li>
          <li>Scrape</li>
          <li>Redistribute</li>
        </ul>
        <p>without written permission.</p>
      </>
    ),
  },
  {
    id: 11,
    title: "11. Account Suspension",
    content: (
      <>
        <p>We reserve the right to suspend or terminate accounts for:</p>
        <ul>
          <li>Abuse</li>
          <li>Fraud</li>
          <li>Refund exploitation</li>
          <li>Unauthorized scraping</li>
          <li>Data misuse</li>
        </ul>
      </>
    ),
  },
  {
    id: 12,
    title: "12. Changes to Terms",
    content: "We may update these Terms at any time. Continued use constitutes acceptance.",
  },
  {
    id: 13,
    title: "13. Governing Law",
    content: "These Terms are governed by the laws of the State of Delaware, without regard to conflict of law principles. Disputes shall be resolved in Delaware courts.",
  },
  {
    id: 14,
    title: "14. Contact",
    content: (
      <>
        <p>Hooptie LLC</p>
        <p>8 The Green, Suite A</p>
        <p>Dover, Delaware 19901</p>
        <p><a href="mailto:support@hooptie.io">support@hooptie.io</a></p>
      </>
    ),
  },
];

function AccordionSection({ section, isOpen, onToggle }) {
  const content = typeof section.content === "string" ? <p>{section.content}</p> : section.content;
  return (
    <div
      className={`terms-accordion-card ${isOpen ? "terms-accordion-card--open" : ""}`}
      onClick={() => onToggle(section.id)}
    >
      <div className="terms-accordion-header">
        <span className="terms-accordion-title">{section.title}</span>
        <span className="terms-accordion-chevron" aria-hidden>{isOpen ? "▼" : "▶"}</span>
      </div>
      <div className="terms-accordion-body">
        <div className="terms-accordion-content">{content}</div>
      </div>
    </div>
  );
}

export default function TermsOfService() {
  const [openIds, setOpenIds] = useState(new Set([1]));

  const toggleSection = (id) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <div className="terms-page">
      <div className="terms-container">
        <header className="terms-header">
          <img src={hooptieLogo} alt="Hooptie" className="terms-logo" />
          <h1 className="terms-title">Terms of Service</h1>
          <p className="terms-updated">Last Updated: {LAST_UPDATED}</p>
        </header>

        <div className="terms-intro">
          <p>
            Welcome to Hooptie, operated by Hooptie LLC (“Company,” “we,” “our,” or “us”). By accessing or using our platform, you agree to the following Terms of Service (“Terms”).
          </p>
          <p>If you do not agree, you may not use Hooptie.</p>
        </div>

        <div className="terms-accordion">
          {SECTIONS.map((section) => (
            <AccordionSection
              key={section.id}
              section={section}
              isOpen={openIds.has(section.id)}
              onToggle={toggleSection}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
